module.exports = __webpack_public_path__ + "img/avatar.67c0049a.png";